import lang from '../../../lib/language';

import WarningIcon from '../../../assets/img/warning-icon.svg';

import styles from './NotAvailableWithdrawals.module.scss';

const NotAvailableWithdrawals = () => (
  <div className={styles.container}>
    <div className={styles.content}>
      <img className={styles.warningIcon} src={WarningIcon} alt="Warning" />
      <div>{lang.payoutsNotAvailableWithdrawals()}</div>
    </div>
  </div>
);

export default NotAvailableWithdrawals;
